import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index'
// import Layout from '@/layout'
const AboutUs = () => import('@/views/aboutUs') // 关于
const ContactUs = () => import('@/views/contactUs') // 联系我们
const solve = () => import('@/views/solve') // 解决方案
const solveShow = () => import('@/views/solve/solveShow') // 解决方案详情
const newsCenter = () => import('@/views/news/newsMain') // 新闻主页
const newsItemNew = () => import('@/views/news/newsItemNew') // 新闻详情
const productMain = () => import('@/views/product/ProductMain') // 产品中心(下载)
const productMainList = () => import('@/views/product/ProductMainList') // 产品中心(下载)
const wmsView = () => import('@/views/product/wmsView') // Wms系统
const tmsView = () => import('@/views/product/tmsView') // TMs运输
const repView = () => import('@/views/product/repView') // ERP系统
const middleView = () => import('@/views/product/middleView') // 时空中台
const commerce = () => import('@/views/product/commerce') // 电子商务平台
const omsView = () => import('@/views/product/OmsView') // oms系统
const circulateView = () => import('@/views/product/circulateView') // 流通行业信息整体化架构
const productItem = () => import('@/views/product/productItem') // 产品详情下载
const productItemShow = () => import('@/views/product/productItemShow') // 产品详情
const caseView = () => import('@/views/case') // 客户案例
const caseShow = () => import('@/views/case/caseShow') // 解决方案详情
Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    component: () => import('@/views/home'),
    hidden: true
  },
  {
    path: '/aboutUs', // 关于我们
    name: 'aboutUs',
    meta: 'aboutUs',
    component: AboutUs
  },
  {
    path: '/contactUs', // 联系我们
    name: 'contactUs',
    meta: 'contactUs',
    component: ContactUs
  },
  {
    path: '/solve', // 解决方案
    name: 'solve',
    meta: 'solve',
    component: solve
  },
  {
    path: '/solveShow/:id', // 解决方案详情
    name: 'solveShow',
    meta: 'solve',
    component: solveShow
  },
  {
    path: '/newsCenter', // 新闻中心
    name: 'newsCenter',
    meta: 'newsCenter',
    component: newsCenter
  },
  {
    path: '/newsItemNew/:id', // 动态新闻详情
    name: 'newsItemNew',
    meta: 'newsCenter',
    component: newsItemNew
  },
  {
    path: '/productMain', // 产品中心(下载)
    name: 'productMain',
    meta: 'productMain',
    component: productMain
  },
  {
    path: '/productMainList', // 产品中心列表
    name: 'productMainList',
    meta: 'productMain',
    component: productMainList
  },
  {
    path: '/wmsView', // WMS仓库
    name: 'wmsView',
    meta: 'productMain',
    component: wmsView
  }, {
    path: '/omsView', // Oms仓库
    name: 'omsView',
    meta: 'productMain',
    component: omsView
  },
  {
    path: '/tmsView', // TMS运输
    name: 'tmsView',
    meta: 'productMain',
    component: tmsView
  },
  {
    path: '/repView', // ERP系统
    name: 'repView',
    meta: 'productMain',
    component: repView
  },
  {
    path: '/middleView', // 时空中台
    name: 'middleView',
    meta: 'productMain',
    component: middleView
  },
  {
    path: '/commerce', // 电子商务平台
    name: 'commerce',
    meta: 'productMain',
    component: commerce
  },
  {
    path: '/circulateView', // 流通行业信息整体化架构
    name: 'circulateView',
    meta: 'productMain',
    component: circulateView
  },
  {
    path: '/productItem/:id/:name', // 产品详情下载
    name: 'productItem',
    meta: 'productMain',
    component: productItem
  },
  {
    path: '/productItemShow/:id', // 产品详情
    name: 'productItemShow',
    meta: 'productMain',
    component: productItemShow
  },
  {
    path: '/case', // 客户案例
    name: 'case',
    meta: 'case',
    component: caseView
  },
  {
    path: '/caseShow/:id',
    // path: '/caseShow', // 客户案例详情
    name: 'caseShow',
    meta: 'case',
    component: caseShow
  }

]
const routerRePush = VueRouter.prototype.push
VueRouter.prototype.push = function (location) {
  return routerRePush.call(this, location).catch(error => error)
}

const router = new VueRouter({
  routes
})
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})
router.beforeEach((to, from, next) => {
  // console.log(to)
  // if (to.meta === 'home') { }
  store.commit('getActiveIndex', to.path)
  // 跳转新闻和解决详情，把导航index 存vuex
  if (to.meta === 'newsCenter') { store.commit('getActiveIndex', '/newsCenter') }
  if (to.meta === 'solve') { store.commit('getActiveIndex', '/solve') }
  // store.commit('getActiveIndex', to.path)
  next()
})
export default router
